// extracted by mini-css-extract-plugin
module.exports = {"efmenu":"EFMenu_efmenu__iP3Bs"};